import React from 'react';
import { Text } from '@hangar/web-components/core/Text';
import { useTranslation } from '../../hooks/i18n';
import * as S from './Help.styles';

export const Help: React.FC = () => {
  const { t } = useTranslation();

  return (
    <S.HelpContainer>
      <S.HelpContent>
        <Text variant="heading-lg" bold>
          {t('help.title')}
        </Text>
        <S.HelpSection>
          <Text variant="body-md">
            {t('help.description')}
          </Text>
        </S.HelpSection>
        <S.HelpSection>
          <Text variant="heading-md" bold>
            {t('help.contact.title')}
          </Text>
          <Text variant="body-md">
            {t('help.contact.description')}
          </Text>
        </S.HelpSection>
      </S.HelpContent>
    </S.HelpContainer>
  );
};

